




import { Component, Vue } from 'vue-property-decorator';
import ProjectCreateComponent from '@/components/project-create.vue';

@Component({
  components: {
    ProjectCreateComponent
  }
})
export default class ProjectCreatePage extends Vue {
  created(): void {
    this.$store.dispatch('lookup/getAvailableLookup', 1);
    this.$store.dispatch('lookup/getAvailableLookup', 2);
    this.$store.dispatch('lookup/getAvailableLookup', 3);
    this.$store.dispatch('lookup/getAvailableLookup', 4);
    this.$store.dispatch('lookup/getAvailableLookup', 5);
    this.$store.dispatch('lookup/getAvailableLookup', 6);
    this.$store.dispatch('lookup/getAvailableLookup', 7);
    this.$store.dispatch('lookup/getAvailableLookup', 8);
    this.$store.dispatch('lookup/getAvailableLookup', 9);
    this.$store.dispatch('lookup/getAvailableLookup', 10);
    this.$store.dispatch('lookup/getAvailableLookup', 11);
    this.$store.dispatch('lookup/getAvailableLookup', 12);
    this.$store.dispatch('lookup/getAvailableLookup', 13);
    this.$store.dispatch('account/getOtherSolvers', '');
  }
}
